import { CORPORATE_SOLUTIONS } from "../CorporatePortalContent";

export default function CorporateSolutionsPage() {
  return (
    <>
      <section className="corporate-page-banner">
        <div className="corporate-page-banner-inner">
          <h1 className="corporate-page-banner-title">解决方案</h1>
          <p className="corporate-page-banner-desc">
            面向不同行业场景，提供可私有化部署、可量化验收的 AI 产品与定制服务。
          </p>
        </div>
      </section>

      <div className="corporate-page">
        <section className="corporate-section" style={{ paddingTop: 40 }}>
          <div className="corporate-card-grid">
            {CORPORATE_SOLUTIONS.map((item) => (
              <div key={item.id} className="corporate-card">
                <h3 className="corporate-card-title">{item.title}</h3>
                <p className="corporate-card-text">{item.summary}</p>
                <ul className="corporate-highlight-list">
                  {item.highlights.map((line) => (
                    <li key={line}>{line}</li>
                  ))}
                </ul>
                <div className="corporate-tag-list">
                  {item.industries.map((tag) => (
                    <span key={tag} className="corporate-tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="corporate-section">
          <h2 className="corporate-section-title">交付流程</h2>
          <div className="corporate-card-grid corporate-card-grid-3">
            <div className="corporate-card">
              <h3 className="corporate-card-title">1. 诊断与规划</h3>
              <p className="corporate-card-text">梳理业务痛点，明确 KPI 与数据就绪度，输出 PoC 方案。</p>
            </div>
            <div className="corporate-card">
              <h3 className="corporate-card-title">2. 试点验证</h3>
              <p className="corporate-card-text">小范围上线试运行，迭代模型与流程，形成可复制模板。</p>
            </div>
            <div className="corporate-card">
              <h3 className="corporate-card-title">3. 规模化推广</h3>
              <p className="corporate-card-text">多站点/多业务线复制，配套培训、运维与效果复盘机制。</p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
